var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileSorting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99805 -0.000182843C6.55033 -0.000182843 6.99805 0.447532 6.99805 0.999817V14.9998C6.99805 15.5521 6.55033 15.9998 5.99805 15.9998C5.44576 15.9998 4.99805 15.5521 4.99805 14.9998V0.999817C4.99805 0.447532 5.44576 -0.000182843 5.99805 -0.000182843Z",
    fill: "#433E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29094 0.29271C5.68146 -0.0978139 6.31463 -0.0978139 6.70515 0.29271L10.7052 4.29271C11.0957 4.68324 11.0957 5.3164 10.7052 5.70692C10.3146 6.09745 9.68146 6.09745 9.29094 5.70692L5.99805 2.41403L2.70515 5.70692C2.31463 6.09745 1.68146 6.09745 1.29094 5.70692C0.900416 5.3164 0.900416 4.68324 1.29094 4.29271L5.29094 0.29271Z",
    fill: "#433E3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.998 14.9998C15.4458 14.9998 14.998 14.5521 14.998 13.9998L14.998 0.999817C14.998 0.447532 15.4458 -0.000183154 15.998 -0.000183105C16.5503 -0.000183057 16.998 0.447532 16.998 0.999817L16.998 13.9998C16.998 14.5521 16.5503 14.9998 15.998 14.9998Z",
    fill: "#433E3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7052 15.7069C16.3146 16.0974 15.6815 16.0974 15.2909 15.7069L11.2909 11.7069C10.9004 11.3164 10.9004 10.6832 11.2909 10.2927C11.6815 9.90218 12.3146 9.90218 12.7052 10.2927L15.998 13.5856L19.2909 10.2927C19.6815 9.90219 20.3146 9.90219 20.7052 10.2927C21.0957 10.6832 21.0957 11.3164 20.7052 11.7069L16.7052 15.7069Z",
    fill: "#433E3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSorting);
export default __webpack_public_path__ + "static/media/mobileSorting.4890e0f2.svg";
export { ForwardRef as ReactComponent };